"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsPage = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../shared/core");
var components_1 = require("../../../shared/core/components");
var MeterReadingsContext_1 = require("../MeterReadingsContext");
var analytics_subjects_1 = require("../analytics-subjects");
var section_ids_1 = require("../section-ids");
var utils_1 = require("../utils");
var Loading_1 = require("./MeterReadingsData/Loading");
var MeterReadingsData_1 = require("./MeterReadingsData/MeterReadingsData");
var MeterReadingAnalytics = function (_a) {
    var _b;
    var children = _a.children, selectedFuel = _a.selectedFuel;
    var supplies = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext).supplies;
    var features = (0, core_1.useFeatureContext)().features;
    var gas = (0, utils_1.getSupplyMeterInfo)(supplies, 'gas');
    var electricity = (0, utils_1.getSupplyMeterInfo)(supplies, 'electricity');
    var hasGas = !!gas;
    var hasElec = !!electricity;
    var isDualFuel = hasGas && hasElec;
    var isGasOnboarding = supplies.gas.some(function (supply) { return supply.isOnboarding; });
    var isGasInOMRWindow = supplies.gas.some(function (supply) { return supply.isInOMRWindow; });
    var isElecOnboarding = supplies.electricity.some(function (supply) { return supply.isInOMRWindow; });
    var isElecInOMRWindow = supplies.electricity.some(function (supply) { return supply.isInOMRWindow; });
    var isOnboarding = isGasOnboarding || isElecOnboarding;
    var isInOMRWindow = isGasInOMRWindow || isElecInOMRWindow;
    var elecMeterCount = (0, utils_1.countMeters)(supplies.electricity);
    var elecSupplyCount = supplies.electricity.length;
    var isComplex = supplies.electricity.length > 1;
    var meterSummaryFlagEnabled = !!(features && features.meterSummary);
    return (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READS_PAGE_CONTENT, properties: (_b = {
                hasGas: hasGas,
                hasElec: hasElec,
                isDualFuel: isDualFuel,
                isOnboarding: isOnboarding,
                isGasOnboarding: isGasOnboarding,
                isElecOnboarding: isElecOnboarding,
                isGasInOMRWindow: isGasInOMRWindow,
                isElecInOMRWindow: isElecInOMRWindow,
                isInOMRWindow: isInOMRWindow,
                selectedFuel: selectedFuel,
                elecMeterCount: elecMeterCount,
                elecSupplyCount: elecSupplyCount,
                newDesign: isComplex || meterSummaryFlagEnabled
            },
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b) }, children));
};
var PageLoading = function () {
    var Card = (0, core_1.useComponents)().Card;
    return (react_1.default.createElement(Card, null,
        react_1.default.createElement(Loading_1.Loading, null)));
};
var MeterReadingsPage = function (_a) {
    var selectedFuel = _a.selectedFuel, children = _a.children, rest = __rest(_a, ["selectedFuel", "children"]);
    return (
    // eslint-disable-next-line energy-cx/internal-events
    react_1.default.createElement(ui_tools_1.AnalyticsPage, __assign({}, rest),
        react_1.default.createElement(components_1.ErrorBoundary, { id: section_ids_1.METER_READ_PAGE_ERROR },
            react_1.default.createElement(MeterReadingsData_1.MeterReadingsData, { selectedFuel: selectedFuel, NoData: PageLoading },
                react_1.default.createElement(MeterReadingAnalytics, { selectedFuel: selectedFuel }, children)))));
};
exports.MeterReadingsPage = MeterReadingsPage;
